<section class="py-24 bg-gray-50 bg-primary-200">

  <div class="w-11/12 mx-auto">

    <h2 class="text-4xl font-light mb-14">
      Platform Coverage
    </h2>

    <div class="grid md:grid-cols-3 gap-10 text-lg">

      <div class="bg-white p-8 rounded-xl shadow-sm">

        <h3 class="font-semibold mb-3">
          SAP Platforms
        </h3>

        <p class="text-gray-700">
          Implementation, operations, and modernization across
          enterprise SAP landscapes including S/4HANA.
        </p>

      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm">

        <h3 class="font-semibold mb-3">
          Enterprise Integration
        </h3>

        <p class="text-gray-700">
          API architecture, middleware integration,
          and enterprise system connectivity.
        </p>

      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm">

        <h3 class="font-semibold mb-3">
          Digital Platforms
        </h3>

        <p class="text-gray-700">
          Enterprise applications, analytics platforms,
          and automation solutions.
        </p>

      </div>

    </div>

  </div>

</section>